const hero = {
	state:    {
		videoDuration: 0,
		videoLoop:     true,
		currentTime:   0,
	},
	selector: {},
	elements: {
		$heroSection:         $('.js-hero'),
		$heroBackground:      $('.js-hero-background'),
		$heroBackgroundVideo: $('.js-hero-background-video'),
		$heroBottomVideo:     $('.js-hero-bottom-video'),
		$heroBottomCta:       $('.js-hero-bottom-cta'),
		$fixedContactButton:  $('.js-contact-fixed'),
	},

	init() {
		this.setVideoSrc(this.elements.$heroBackgroundVideo)
		this.setVideoSrc(this.elements.$heroBottomVideo)

		this.initAnimations()
	},

	setVideoSrc(video) {
		const src = window.isMobile ? video.attr('data-src-mobile') : video.attr('data-src-desktop')

		video.attr('src', src)
		video[0].play()
	},

	initAnimations() {
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.$heroSection,
				start:               'top top',
				end:                 () => `+=${window.vh * 200}`,
				scrub:               true,
				invalidateOnRefresh: true,
			},
		}).to(this.elements.$heroBottomVideo, {
			'--progress': 1,
		})
	},
}
export default hero
